import './InstagramBtn.css.proxy.js';
/* src/components/button/InstagramBtn.svelte generated by Svelte v3.35.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_element,
	claim_text,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	text
} from "../../web_modules/svelte/internal.js";

function create_fragment(ctx) {
	let a;
	let img;
	let img_src_value;
	let p;
	let span0;
	let t0;
	let br;
	let span1;
	let t1;

	return {
		c() {
			a = element("a");
			img = element("img");
			p = element("p");
			span0 = element("span");
			t0 = text("Instagram");
			br = element("br");
			span1 = element("span");
			t1 = text("インスタグラム");
			this.h();
		},
		l(nodes) {
			a = claim_element(nodes, "A", {
				href: true,
				target: true,
				rel: true,
				class: true
			});

			var a_nodes = children(a);
			img = claim_element(a_nodes, "IMG", { src: true, alt: true, class: true });
			p = claim_element(a_nodes, "P", { class: true });
			var p_nodes = children(p);
			span0 = claim_element(p_nodes, "SPAN", { class: true });
			var span0_nodes = children(span0);
			t0 = claim_text(span0_nodes, "Instagram");
			span0_nodes.forEach(detach);
			br = claim_element(p_nodes, "BR", {});
			span1 = claim_element(p_nodes, "SPAN", { class: true });
			var span1_nodes = children(span1);
			t1 = claim_text(span1_nodes, "インスタグラム");
			span1_nodes.forEach(detach);
			p_nodes.forEach(detach);
			a_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = "/images/instagram_white.png")) attr(img, "src", img_src_value);
			attr(img, "alt", "");
			attr(img, "class", "svelte-muy1ar");
			attr(span0, "class", "svelte-muy1ar");
			attr(span1, "class", "svelte-muy1ar");
			attr(p, "class", "svelte-muy1ar");
			attr(a, "href", "https://www.instagram.com/lalbero_aoki/");
			attr(a, "target", "_blank");
			attr(a, "rel", "noopener noreferrer");
			attr(a, "class", "svelte-muy1ar");
		},
		m(target, anchor) {
			insert(target, a, anchor);
			append(a, img);
			append(a, p);
			append(p, span0);
			append(span0, t0);
			append(p, br);
			append(p, span1);
			append(span1, t1);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(a);
		}
	};
}

class InstagramBtn extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default InstagramBtn;
//# sourceMappingURL=InstagramBtn.js.map
